import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import '../styles/EmployeeMaster.css';
import SubmodalityTable from '../components/SubmodalityTable';

const Submodality = () => {
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/submodality/add';

  const handleAddClick = () => {
    
    navigate('/submodality/add');
  };

  const handleCloseModal = () => {
    navigate('/submodality');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Submodality Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Sub Modality
        </button>
      </div>

      <SubmodalityTable />
    </div>
  );
};

export default Submodality;